import { TOGGLE_YEAR,
         SELECT_MONTH,
         CANCEL_SELECTED_MONTH,
         SELECT_SIMILAR_EXRATE_MONTHS } from '../actions/index';

import touristsData from '../../data/open_data_3_beta.csv';

const INITIAL_STATE = {
  displayedYear: {
    103: true,
    104: true,
    105: true,
  },
  selectedMonth: null,
  comparedMonths: [],
};

const EXCAHNGE_THRESHOLD = 0.2;

const date = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TOGGLE_YEAR:
      return { ...state,
               displayedYear: {
                 ...state.displayedYear,
                 [action.payload]: !state.displayedYear[action.payload],
               },
              };

    case SELECT_MONTH: {
      const indexOfMonthInComparedMonths = state.comparedMonths.findIndex(d =>
        d.year === action.payload.year && d.month === action.payload.month);
      const comparedMonths = state.comparedMonths.slice(0); // just copy

      let selectedMonth = null;
      if (indexOfMonthInComparedMonths === -1) {
        comparedMonths.push(action.payload);
        selectedMonth = touristsData.find(d =>
          d.year === action.payload.year &&
          d.month === action.payload.month);
      } else {
        comparedMonths.splice(indexOfMonthInComparedMonths, 1);
        const lastSelectedMonth = comparedMonths[comparedMonths.length - 1];

        if (lastSelectedMonth) {
          selectedMonth = touristsData.find(d =>
            d.year === lastSelectedMonth.year &&
            d.month === lastSelectedMonth.month);
        }
      }

      return { ...state,
              selectedMonth,
              comparedMonths,
              };
    }

    case CANCEL_SELECTED_MONTH:
      return { ...state,
               selectedMonth: null,
               comparedMonths: [] };

    case SELECT_SIMILAR_EXRATE_MONTHS: {
      const filteredData = touristsData.filter(d =>
        Math.abs(d.avgExchangeRate - state.selectedMonth.avgExchangeRate) < EXCAHNGE_THRESHOLD
      );
      const filteredResult = [];
      filteredData.forEach(d => {
        filteredResult.push({ year: d.year, month: d.month });
      });
      return { ...state,
               comparedMonths: filteredResult };
    }

    default:
      return state;
  }
};

export default date;



/** WEBPACK FOOTER **
 ** ./src/reducers/date_reducer.js
 **/